import { Select as BaseSelect, SelectProps, useStyleConfig, forwardRef } from '@chakra-ui/react';
import React from 'react';

const Select = forwardRef<SelectProps, 'select'>(({ children, ...rest }, ref) => {
  const styles = useStyleConfig('Select');
  return (
    <BaseSelect ref={ref} sx={styles} {...rest}>
      {children}
    </BaseSelect>
  );
});

export default Select;
